import { render } from "./SectionSection.vue?vue&type=template&id=0527bcb3"
import script from "./SectionSection.vue?vue&type=script&lang=js"
export * from "./SectionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__